import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Settings } from './settings';
import { ChartDetails } from '../models/chart-details';
import { MetricCard } from '../models/metric-card';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }
  
  getChartDetails(): Observable<ChartDetails[]> {
      return this.http.get<ChartDetails[]>(Settings.getInstance().BASE_URL + 'home/getCharts')
      .pipe(
        retry(1)
      )
  }
  
  getMetricCards(): Observable<MetricCard[]> {
      return this.http.get<MetricCard[]>(Settings.getInstance().BASE_URL + 'home/getMetricCards')
      .pipe(
        retry(1)
      )
  }
  getCharts(): Observable<any> {
      return this.http.get<any>(Settings.getInstance().BASE_URL + 'home/getCharts')
          .pipe(
              retry(1)
          )
  }
  getChart(chart: string, portfolioId: any, fiscalYear: any): Observable<any> {
	  let url = Settings.getInstance().BASE_URL + 'home/'+chart;
	  if(portfolioId != null && portfolioId != undefined) {
		url = url + '/'+portfolioId
	  }
	  if(fiscalYear != null && fiscalYear != undefined) {
		url = url + '/'+fiscalYear
	  }
      return this.http.get<any>(url)
      .pipe(
        retry(1)
      )
  }
}
